import requestMaker from 'lib';
import { cookieKey } from 'assets/Constants';

export const getFirebaseToken = async () => {
  try {
    const baseQuery = `/proxy/prv/us/gft`;
    return requestMaker(baseQuery, {});
  } catch (error) {
    localStorage.removeItem(cookieKey);
    localStorage.removeItem('fb_t');
  }
};

export const signupGuestUser = data => {
  const baseQuery = `/proxy/ath/us/sgu`;
  const params = {};
  const payload = { ...data };
  return requestMaker(baseQuery, { params, payload });
};
